import { Component } from '@angular/core';
import { Medium } from 'src/api/generated';
import { TrashService } from 'src/app/shared/services/trash.service';

@Component({
  selector: 'app-medium-trash',
  templateUrl: './medium-trash.component.html',
  styleUrl: './medium-trash.component.scss'
})
export class MediumTrashComponent {

  constructor(
    private _tSvc: TrashService
  ) { }

  public get TSvc(): TrashService {
    return this._tSvc;
  }

  onFocusedRowChanged(e: any) {
    const rowData = e.row && e.row.data;

    if (rowData) {
      this._tSvc.CurrentMediumRow = rowData as Medium;
    }
  }
}
